import React from 'react'
import { cn } from '@/lib/utils'

interface LogoProps extends React.SVGProps<SVGSVGElement> {
  className?: string
}

export default function Logo({ className, ...props }: LogoProps) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="1024.000000pt"
      height="1024.000000pt"
      viewBox="0 0 1024.000000 1024.000000"
      preserveAspectRatio="xMidYMid meet"
      className={cn('fill-current', className)}
      {...props}
    >
      <g
        transform="translate(0,1024) scale(0.1,-0.1)"
        fill="currentColor"
        stroke="none"
      >
        <path
          d="M6515 8566 c-48 -48 -55 -147 -19 -276 34 -119 91 -199 203 -286 l74
-58 -28 -24 c-20 -17 -35 -22 -52 -17 -41 10 -342 7 -422 -5 -41 -6 -112 -20
-158 -31 l-85 -21 -32 29 c-17 16 -64 55 -104 87 -91 72 -112 104 -112 174 0
64 -20 106 -60 127 -43 22 -92 19 -135 -10 -20 -15 -38 -25 -40 -23 -1 2 -24
45 -50 95 -48 95 -90 142 -128 144 -72 4 -108 -18 -128 -79 -28 -84 22 -289
94 -390 18 -26 36 -52 40 -59 4 -7 -27 4 -70 24 -167 77 -345 123 -398 103
-35 -13 -78 -107 -107 -231 -19 -80 -22 -124 -23 -289 0 -202 10 -303 47 -447
l20 -83 -30 -25 c-22 -19 -34 -41 -43 -81 -15 -66 -31 -73 -127 -56 -164 28
-296 152 -341 320 -13 48 -24 51 -83 21 -46 -24 -88 -65 -88 -87 0 -25 91
-152 155 -217 128 -128 321 -187 461 -139 25 8 48 14 50 11 10 -10 -82 -130
-134 -177 -86 -77 -163 -111 -264 -117 -108 -7 -175 12 -242 67 -26 22 -51 40
-55 40 -29 0 -81 -98 -81 -154 0 -33 2 -35 78 -65 98 -39 151 -50 232 -51 157
0 332 83 407 193 15 23 56 96 91 162 l63 120 -4 -54 c-3 -39 -17 -79 -52 -147
-41 -80 -53 -96 -79 -102 -29 -8 -32 -13 -56 -105 -21 -82 -23 -100 -12 -118
11 -18 9 -25 -18 -58 -53 -68 -150 -151 -231 -198 -78 -45 -93 -65 -67 -91 14
-14 19 -10 -77 -64 -149 -84 -219 -115 -480 -213 -358 -134 -471 -185 -468
-211 2 -16 -11 -27 -55 -48 -151 -74 -372 -250 -522 -416 -125 -139 -182 -215
-165 -218 8 -2 15 -6 15 -8 0 -3 -29 -42 -64 -87 -69 -90 -151 -214 -210 -320
-21 -37 -41 -65 -45 -62 -5 2 -16 33 -27 67 -23 80 -23 245 0 340 70 295 235
499 666 820 315 235 400 313 513 470 165 231 249 538 219 797 -6 55 -19 119
-29 142 l-16 42 -19 -23 -18 -22 0 25 c0 40 -48 184 -88 262 -47 95 -122 205
-166 243 -42 37 -56 40 -56 12 0 -15 -17 -5 -86 50 -99 79 -234 150 -300 158
-40 4 -44 3 -37 -13 5 -15 3 -17 -13 -11 -10 4 -61 10 -114 13 -166 10 -387
-45 -470 -117 -32 -27 -34 -31 -18 -43 15 -12 11 -17 -37 -56 -70 -54 -142
-155 -166 -232 -27 -88 -25 -169 6 -169 7 0 15 -18 19 -41 10 -61 50 -132 98
-173 86 -74 208 -84 348 -27 122 49 196 39 272 -39 60 -63 77 -125 59 -230
-32 -195 -174 -377 -516 -661 -184 -152 -384 -349 -458 -449 -271 -369 -375
-865 -261 -1258 28 -97 28 -92 10 -92 -13 0 -12 -9 4 -54 27 -80 121 -258 190
-364 65 -98 213 -260 280 -307 l40 -28 0 -70 c0 -94 19 -196 40 -217 9 -9 27
-59 39 -111 27 -118 86 -268 141 -361 45 -75 171 -214 215 -238 22 -12 28 -12
35 0 6 10 22 1 66 -38 73 -65 167 -115 310 -163 250 -84 536 -129 1079 -169
164 -12 459 -7 528 9 83 19 165 67 199 116 l32 45 82 0 c259 0 548 45 740 114
l66 24 61 -65 c119 -127 229 -189 399 -224 91 -18 129 -20 318 -17 201 4 220
6 287 30 90 33 139 66 174 118 33 50 43 110 28 181 -22 105 -70 169 -174 234
-57 36 -78 55 -93 88 -24 51 -62 172 -62 198 0 20 138 142 151 133 5 -3 9 -11
9 -18 0 -45 106 -378 144 -455 106 -211 227 -272 536 -273 350 -1 503 85 487
273 -9 102 -66 179 -177 238 -87 46 -95 78 -94 361 0 223 0 221 63 580 40 232
59 409 72 675 12 247 14 265 33 265 38 0 59 137 54 348 -3 130 -8 176 -22 207
-25 57 -56 157 -56 180 1 17 4 16 25 -10 34 -41 68 -133 61 -167 -4 -20 -1
-28 8 -28 54 0 3 255 -109 545 -26 66 -49 128 -52 137 -3 10 19 53 56 108 33
51 68 113 77 139 9 25 26 66 36 91 11 25 22 73 25 108 4 42 10 62 19 62 20 0
27 42 19 104 l-6 55 -91 21 c-50 12 -92 20 -93 18 -2 -2 -13 -25 -25 -52 -48
-113 -133 -176 -249 -183 -36 -2 -87 -5 -113 -7 -27 -2 -48 1 -48 5 0 17 44
31 125 39 95 10 144 31 196 87 31 32 69 91 69 107 0 2 -14 7 -30 11 -27 6 -37
1 -80 -39 -58 -54 -73 -61 -158 -70 -81 -9 -110 -22 -129 -60 -20 -38 -30 -17
-13 25 16 38 49 55 129 63 71 8 135 36 150 65 13 23 -2 31 -62 32 -36 1 -38 2
-17 9 14 4 44 8 67 9 32 1 45 6 53 22 6 11 10 23 8 28 -2 4 -47 0 -100 -9 -54
-9 -94 -12 -89 -7 4 4 56 20 115 34 104 26 108 28 127 64 40 79 34 201 -16
312 -13 29 -46 88 -74 132 -54 84 -94 177 -88 204 2 9 17 -11 36 -49 18 -36
66 -123 107 -195 100 -178 125 -284 89 -385 -8 -23 -15 -44 -15 -47 0 -2 27
-1 59 3 62 7 111 0 111 -15 0 -5 -29 -11 -65 -13 -35 -2 -67 -7 -71 -10 -3 -4
-3 -23 0 -42 6 -29 12 -37 34 -41 74 -16 240 -76 347 -127 83 -40 111 -50 90
-33 -39 33 -147 89 -227 119 -66 24 -82 42 -94 105 l-6 31 53 0 c49 -1 145 -8
289 -24 37 -4 48 -3 34 3 -28 13 -200 38 -311 46 -51 4 -93 10 -93 14 1 3 18
18 39 32 46 32 81 100 81 157 0 49 -10 57 -47 39 -15 -8 -41 -17 -56 -21 l-28
-7 27 52 c22 45 26 62 22 121 -4 82 -25 113 -56 85 -10 -9 -34 -23 -55 -32
-36 -15 -37 -15 -69 14 -33 29 -33 30 -16 59 36 62 35 168 -3 231 l-20 33 -44
-41 c-39 -35 -65 -51 -65 -37 0 2 9 23 20 47 38 84 15 268 -34 277 -11 2 -33
-11 -56 -33 l-37 -36 -6 138 c-7 161 -26 273 -68 387 -36 97 -75 157 -111 170
-36 13 -147 -42 -248 -123 -41 -33 -78 -57 -83 -54 -4 3 -22 23 -38 45 -26 37
-29 48 -29 120 0 75 -2 81 -29 109 -36 35 -90 39 -139 9 l-33 -20 -20 47 c-68
163 -85 183 -151 183 -28 0 -46 -7 -63 -24z m106 -37 c22 -22 74 -127 67 -134
-2 -3 -21 18 -41 45 -27 36 -44 50 -62 50 -31 0 -40 -30 -32 -112 9 -97 62
-192 168 -301 90 -92 148 -172 134 -185 -4 -4 -19 9 -33 28 -27 36 -51 60
-160 163 -95 91 -160 246 -150 363 8 94 59 133 109 83z m-1228 -123 c22 -21
94 -146 83 -146 -2 0 -22 25 -45 55 -103 136 -157 39 -86 -152 49 -130 136
-228 304 -343 89 -61 132 -105 151 -154 15 -41 -5 -31 -43 22 -38 51 -57 66
-187 152 -102 68 -189 153 -229 223 -68 120 -92 287 -50 341 26 33 67 34 102
2z m1499 -63 c26 -30 30 -61 18 -135 -10 -57 -14 -68 -22 -53 -6 10 -8 41 -4
69 4 38 2 58 -10 74 -30 44 -74 23 -123 -58 l-21 -35 0 29 c0 33 32 89 63 111
29 20 80 19 99 -2z m-1182 -121 c26 -21 40 -95 29 -147 -6 -30 -6 -30 -12 -5
-3 14 -9 42 -12 62 -3 21 -13 44 -21 53 -39 39 -107 -2 -120 -71 -11 -66 -23
-74 -24 -16 0 86 41 142 106 142 18 0 42 -8 54 -18z m1679 -86 c32 -87 49
-164 61 -276 9 -94 6 -261 -6 -299 -3 -10 -29 9 -79 59 -41 41 -75 78 -75 82
0 5 23 8 50 8 28 0 50 4 50 10 0 16 -36 30 -76 30 l-37 0 19 22 c10 11 39 34
63 50 l45 28 -37 0 c-21 0 -53 -7 -72 -14 -19 -8 -35 -11 -35 -6 0 5 28 39 63
76 58 63 60 67 32 60 -37 -9 -113 -57 -145 -91 -55 -58 -47 -18 26 130 50 104
105 185 124 185 5 0 18 -24 29 -54z m-348 -110 c61 -75 129 -219 109 -231 -14
-9 -39 23 -77 99 -20 39 -52 96 -73 126 -40 60 -70 114 -70 127 1 9 47 -42
111 -121z m-1063 -190 c39 -38 54 -66 33 -66 -21 0 -211 182 -211 202 0 10
120 -81 178 -136z m-893 89 c91 -41 213 -133 297 -223 68 -72 141 -172 133
-180 -3 -3 -27 16 -54 41 -99 92 -220 152 -332 164 -32 3 -59 3 -59 0 0 -4 26
-20 58 -36 57 -29 182 -125 182 -140 0 -4 -30 1 -67 10 -70 18 -146 22 -198 9
-33 -8 -28 -11 50 -29 57 -13 157 -61 162 -77 2 -7 -16 -14 -45 -18 -27 -3
-69 -19 -95 -36 -46 -29 -63 -56 -29 -46 50 15 96 17 146 6 58 -12 66 -19 42
-39 -10 -8 -27 -8 -66 0 -36 8 -55 8 -62 1 -16 -16 -11 -147 8 -207 16 -50 16
-55 0 -79 -9 -14 -22 -26 -28 -26 -18 0 -89 81 -127 144 -46 77 -97 230 -117
351 -28 172 -5 384 47 436 25 25 55 20 154 -26z m252 5 c69 -26 201 -99 278
-155 59 -42 144 -139 132 -151 -3 -3 -39 23 -79 58 -98 84 -154 125 -283 203
-60 36 -107 65 -105 65 3 0 28 -9 57 -20z m1616 -84 c51 -13 127 -40 168 -60
74 -36 175 -104 166 -112 -2 -3 -44 15 -93 40 -49 25 -146 61 -216 80 -70 20
-139 41 -153 46 -24 9 -25 8 -25 -27 0 -36 0 -37 -15 -16 -8 12 -18 36 -22 54
l-6 32 52 -7 c28 -4 93 -17 144 -30z m-810 -108 c14 -18 28 -44 32 -58 6 -21
0 -18 -40 21 l-47 47 -37 -37 c-21 -20 -77 -58 -127 -84 -121 -64 -208 -132
-331 -255 -58 -57 -106 -102 -108 -100 -8 7 63 105 121 168 84 90 207 184 309
237 101 51 123 68 136 101 8 22 10 22 38 7 17 -8 41 -30 54 -47z m403 41 c39
-15 77 -41 125 -86 43 -41 75 -63 86 -61 10 2 26 20 36 41 17 37 18 37 46 23
42 -22 106 -99 119 -144 24 -80 11 -131 -62 -241 -30 -44 -60 -104 -67 -132
-7 -28 -19 -54 -26 -56 -7 -3 -32 12 -54 32 -37 33 -134 85 -160 85 -34 0
-173 66 -213 102 -68 59 -90 107 -91 195 0 39 3 75 8 79 4 4 29 -3 57 -16 40
-19 54 -21 73 -13 22 10 23 16 19 67 -2 30 -1 76 2 101 8 53 17 55 102 24z
m1086 -201 c18 -34 15 -147 -5 -185 -24 -45 -40 -42 -31 5 7 36 6 37 -13 20
-32 -29 -33 -22 -5 47 14 36 23 68 20 71 -4 3 -32 -8 -65 -25 -63 -33 -123
-49 -123 -34 0 5 23 20 51 33 28 13 71 39 97 56 57 40 58 40 74 12z m-286 -6
c14 -9 34 -47 34 -64 -1 -7 -8 -1 -16 15 -26 48 -46 29 -59 -58 -4 -27 -13
-62 -21 -76 -25 -50 -74 -47 -55 3 12 31 4 68 -15 68 -20 0 -34 -33 -34 -80 0
-56 -25 -113 -47 -108 -10 2 -17 11 -15 20 4 23 -16 32 -34 17 -11 -9 -13 -23
-9 -49 8 -50 -17 -113 -41 -103 -14 5 -16 2 -10 -21 4 -15 0 -49 -9 -78 -8
-28 -15 -80 -15 -115 0 -36 -4 -62 -9 -59 -16 11 -22 100 -10 156 7 30 12 75
13 100 1 38 4 45 26 50 23 6 25 11 22 55 -3 68 18 99 63 91 l32 -6 5 49 c6 63
30 101 64 101 13 0 27 -7 30 -15 11 -27 22 -16 29 28 12 71 44 104 81 79z
m-4476 -43 c44 -10 126 -56 117 -65 -3 -3 -31 4 -64 15 -32 11 -95 23 -138 26
l-80 7 40 -27 c55 -38 93 -73 126 -119 33 -45 39 -82 12 -71 -80 33 -253 49
-314 30 -20 -7 -17 -10 29 -21 109 -28 199 -124 116 -124 -13 0 -24 -2 -24 -5
0 -3 16 -26 36 -52 l37 -48 -34 -2 c-165 -13 -178 -20 -121 -68 23 -20 42 -40
42 -44 0 -4 -16 -15 -35 -24 -37 -17 -75 -69 -75 -100 0 -25 -24 -16 -28 11
-5 33 26 81 64 99 19 9 33 22 31 27 -2 6 -24 22 -50 36 -26 14 -47 28 -47 32
0 14 63 40 126 51 l64 12 -30 37 -31 37 31 16 c39 20 30 34 -42 65 -45 19 -65
22 -149 18 -54 -2 -95 0 -93 4 9 14 88 51 139 64 67 18 220 18 280 -1 27 -8
51 -12 53 -10 12 12 -99 109 -162 141 -39 19 -70 38 -69 42 6 21 166 29 243
11z m2628 -51 c7 -7 12 -16 12 -20 0 -15 -27 -8 -45 12 -18 19 -17 20 1 20 11
0 25 -5 32 -12z m-43 -69 c4 -6 5 -13 1 -16 -8 -8 -56 6 -56 17 0 13 47 13 55
-1z m1956 -29 l39 32 10 -27 c13 -34 13 -72 0 -80 -6 -4 -10 6 -10 23 0 16 -3
31 -6 34 -3 3 -28 -9 -55 -28 -28 -18 -76 -47 -108 -64 -121 -65 -203 -187
-220 -329 -15 -120 8 -212 78 -316 29 -42 26 -53 -5 -24 -104 97 -137 244 -94
414 35 138 105 229 222 290 60 32 73 43 87 79 l16 41 3 -38 3 -38 40 31z m344
-62 c19 -58 -5 -178 -35 -178 -12 0 -12 23 0 74 12 54 3 63 -30 31 l-27 -26
-6 23 c-5 18 2 30 36 60 49 44 54 45 62 16z m-1864 -43 c46 -31 85 -52 86 -48
0 5 4 20 7 34 7 31 53 54 87 44 13 -4 49 -33 81 -63 32 -30 59 -53 61 -51 1 2
7 13 13 24 7 13 24 21 48 23 39 3 41 2 110 -83 20 -24 27 -28 37 -17 23 22 48
13 73 -27 14 -21 36 -41 50 -45 35 -9 118 -106 155 -182 45 -93 35 -113 -14
-29 -51 87 -117 160 -167 186 -25 13 -43 31 -50 50 -11 33 -23 37 -36 12 -9
-16 -12 -16 -35 0 -14 9 -34 29 -44 43 -10 15 -28 37 -40 50 -42 45 -92 19
-52 -27 24 -28 14 -34 -38 -24 -25 4 -55 24 -97 64 -66 63 -92 77 -111 61 -19
-15 -5 -60 22 -73 26 -12 26 -30 -1 -35 -37 -8 -87 10 -148 52 -85 58 -122 76
-155 76 -39 0 -60 -15 -46 -32 21 -28 22 -49 3 -68 -23 -23 -72 -26 -135 -9
-60 16 -265 111 -260 119 7 12 110 -15 195 -50 88 -37 151 -51 174 -38 15 8
15 11 1 31 -8 12 -15 27 -15 34 0 23 62 53 111 53 40 0 59 -8 130 -55z m-625
-82 c33 -32 95 -82 138 -110 60 -40 73 -53 55 -53 -13 1 -35 7 -49 15 -37 21
-46 18 -22 -8 26 -28 28 -37 6 -37 -13 0 -14 -3 -5 -14 24 -29 -10 -27 -50 2
-53 40 -104 107 -123 165 -15 44 -21 97 -12 97 2 0 30 -26 62 -57z m2142 -32
c21 -7 43 -6 59 0 32 12 41 4 20 -18 -13 -15 -14 -27 -6 -68 27 -138 -49 -279
-176 -329 -67 -26 -167 -40 -176 -25 -27 44 -18 245 13 302 11 20 13 18 19
-25 13 -86 88 -218 125 -218 26 0 47 49 48 113 1 85 -20 149 -64 200 l-38 42
31 17 c36 19 96 23 145 9z m-1329 -57 c176 -3 236 -15 347 -69 98 -48 198
-153 253 -268 45 -91 57 -151 47 -222 -6 -37 -10 -44 -21 -35 -9 7 -12 23 -8
44 13 80 -68 257 -162 352 -67 69 -152 116 -247 139 -95 23 -331 31 -434 15
-64 -10 -101 -11 -147 -3 -34 6 -64 9 -65 8 -2 -2 5 -23 16 -48 35 -79 121
-147 186 -147 14 0 69 23 123 51 77 40 111 52 161 56 l63 6 -12 -29 c-18 -45
-14 -171 7 -237 10 -32 32 -75 50 -95 29 -33 33 -35 49 -22 56 46 81 205 48
303 -11 31 -18 57 -15 57 3 0 27 -14 53 -31 72 -46 116 -101 167 -208 26 -53
48 -99 50 -103 2 -5 -16 -8 -40 -8 -23 0 -79 -12 -123 -26 -230 -75 -437 4
-526 201 -27 61 -28 62 -84 74 -91 20 -170 93 -196 182 -16 53 -8 70 30 59 32
-9 84 -12 164 -11 l48 1 -20 26 c-33 41 -25 45 30 16 49 -25 60 -26 208 -28z
m-1127 -68 c13 -26 15 -37 6 -34 -19 7 -58 68 -58 92 1 21 1 21 16 1 9 -11 25
-37 36 -59z m1919 21 c24 -18 49 -72 49 -107 0 -34 -30 -70 -59 -70 -67 0
-115 122 -69 177 13 16 58 16 79 0z m1063 -33 c10 -37 -19 -126 -49 -154 -30
-28 -33 -13 -10 43 8 20 15 47 15 61 0 22 -4 24 -43 24 -24 -1 -49 2 -55 6
-23 14 -11 26 26 26 20 1 51 7 67 14 36 16 41 14 49 -20z m-294 17 c0 -5 -7
-14 -15 -21 -21 -17 -19 -26 15 -74 77 -107 29 -216 -95 -216 -42 0 -78 -31
-73 -63 4 -25 38 -37 38 -13 0 9 5 16 10 16 6 0 10 -11 10 -25 0 -18 -8 -29
-26 -37 -24 -11 -29 -9 -51 16 -33 38 -25 68 37 131 65 68 80 101 80 179 0 85
12 116 45 116 14 0 25 -4 25 -9z m216 -106 c-3 -8 -10 -15 -16 -15 -14 0 -12
37 3 43 15 5 21 -8 13 -28z m-2855 -13 c46 -21 98 -45 114 -52 25 -11 27 -14
11 -18 -38 -8 -216 73 -216 99 0 13 -2 13 91 -29z m327 6 c15 -15 16 -65 1
-74 -8 -4 -1 -13 17 -23 l29 -16 -28 -3 c-15 -2 -51 3 -79 12 -58 17 -68 14
-68 -18 0 -52 34 -121 83 -168 42 -40 47 -48 29 -48 -33 0 -97 64 -122 123
-22 50 -33 157 -18 172 4 4 32 -3 64 -14 31 -12 59 -19 63 -16 3 4 5 24 5 46
-1 41 4 47 24 27z m-227 -206 c46 -28 95 -62 109 -77 l24 -26 -29 13 c-88 39
-188 105 -257 170 -68 63 -59 78 11 20 32 -27 97 -72 142 -100z m-255 93 c-7
-38 -26 -39 -26 -1 0 21 19 50 28 41 2 -2 1 -20 -2 -40z m3169 -12 c-14 -59
-86 -133 -128 -133 -24 0 -22 8 20 54 l37 40 -37 9 c-55 13 -48 37 11 38 26 0
56 4 67 9 33 14 38 11 30 -17z m-4777 -71 c41 -63 62 -123 71 -202 l7 -65 17
39 c9 21 27 81 39 132 13 52 27 93 33 91 19 -7 66 -112 72 -164 3 -29 10 -53
14 -53 5 0 24 29 41 65 18 36 36 65 40 65 12 0 10 -97 -3 -165 -10 -54 -57
-166 -59 -138 0 6 9 50 21 98 11 48 19 91 17 97 -2 6 -22 -13 -43 -43 l-39
-54 -8 70 c-8 72 -33 161 -48 170 -4 3 -13 -25 -20 -60 -13 -70 -72 -205 -90
-205 -5 0 -10 23 -10 53 0 29 -7 79 -15 110 -15 59 -58 151 -74 161 -5 4 -17
-20 -26 -51 -17 -60 -60 -143 -74 -143 -4 0 -18 11 -31 25 -13 14 -27 25 -30
25 -4 0 -20 -18 -35 -41 l-27 -41 -23 50 c-13 27 -37 60 -54 73 -29 22 -42 49
-22 49 17 0 71 -52 88 -83 l16 -31 23 27 c28 32 29 32 61 7 14 -11 29 -20 34
-20 11 0 44 93 59 162 10 51 14 57 29 48 10 -5 32 -31 49 -58z m2238 -107 c26
-137 77 -229 160 -285 44 -31 46 -31 112 -21 111 17 254 23 297 13 39 -9 37
-9 -40 -16 -44 -4 -124 -11 -178 -17 l-98 -11 48 -49 48 -48 79 25 c82 26 166
41 166 31 0 -4 -46 -21 -102 -38 -90 -28 -100 -33 -83 -45 10 -7 52 -21 93
-30 96 -21 160 -15 296 31 122 41 201 46 256 17 48 -27 51 -46 3 -25 -64 27
-134 19 -278 -31 -103 -37 -143 -46 -196 -46 -71 0 -156 21 -205 51 -17 10
-37 19 -43 19 -19 0 -171 -72 -171 -81 0 -11 82 -67 125 -85 19 -8 68 -19 108
-24 101 -14 190 0 366 59 219 74 237 76 372 51 68 -13 127 -19 148 -15 108 20
261 152 261 225 0 11 5 20 10 20 6 0 10 -13 10 -29 0 -36 48 -81 114 -106 62
-24 110 -10 161 46 39 43 55 46 35 7 -59 -114 -160 -127 -297 -38 -21 13 -26
11 -80 -41 -121 -115 -205 -139 -378 -104 -53 10 -104 15 -129 11 -22 -4 -122
-35 -221 -69 l-180 -62 -125 0 c-150 1 -210 20 -290 92 l-51 46 -42 -23 c-23
-13 -80 -48 -127 -79 -140 -92 -149 -97 -95 -47 45 41 212 160 236 168 6 2 7
11 4 21 -5 12 -18 17 -46 17 -46 0 -100 20 -145 55 l-33 25 -82 -30 c-45 -17
-84 -28 -87 -26 -2 3 30 21 72 40 l77 35 -16 30 c-20 40 -20 41 15 41 17 0 57
11 90 24 33 14 60 21 60 16 0 -12 -44 -45 -80 -60 -32 -13 -42 -35 -12 -27 9
3 62 18 117 33 55 15 101 28 102 29 2 1 -19 24 -46 52 -26 27 -60 75 -75 105
-42 86 -70 280 -49 335 5 13 10 4 16 -32 4 -27 15 -86 23 -130z m-121 101 c27
-12 35 -21 35 -40 0 -35 -21 -33 -65 5 -55 48 -41 64 30 35z m421 -69 c22 -24
51 -60 66 -80 40 -51 133 -93 247 -112 69 -11 100 -20 118 -37 27 -25 31 -78
7 -102 -27 -28 -94 -18 -94 13 0 27 12 33 31 15 34 -31 54 12 22 48 -23 25
-73 23 -165 -8 -153 -52 -237 -5 -258 148 -10 70 -30 105 -66 114 -19 5 -31 1
-47 -14 -18 -19 -19 -26 -10 -57 12 -37 1 -48 -17 -16 -34 64 9 131 83 131 40
0 49 -5 83 -43z m1609 -34 c-5 -10 -13 -37 -19 -60 -12 -50 -36 -58 -36 -13 0
40 26 90 46 90 12 0 14 -5 9 -17z m-2030 -53 c8 -12 -34 -29 -92 -37 -24 -3
-46 -10 -49 -15 -9 -14 41 -83 81 -114 20 -15 58 -35 83 -43 56 -19 68 -35 30
-39 -36 -4 -105 27 -152 68 -43 38 -96 124 -96 157 0 21 5 22 88 26 48 1 90 4
94 5 4 1 10 -3 13 -8z m1777 -36 c17 -11 7 -46 -21 -72 -16 -15 -32 -41 -35
-58 -4 -17 -18 -41 -31 -54 -31 -29 -62 -19 -81 26 -17 41 -41 55 -85 48 -26
-5 -41 -1 -59 15 l-25 21 24 20 c55 47 265 83 313 54z m-2307 -100 c-25 -54
-45 -105 -45 -111 0 -7 -9 -13 -20 -13 -17 0 -19 5 -14 33 8 48 64 156 92 178
14 11 27 18 28 16 2 -2 -16 -48 -41 -103z m615 16 c6 -11 8 -25 5 -31 -13 -20
-115 16 -115 41 0 6 22 10 50 10 39 0 51 -4 60 -20z m990 -25 c33 -17 70 -75
48 -75 -7 0 -31 14 -53 30 -21 17 -56 33 -77 37 -21 3 -41 10 -44 14 -9 15 95
10 126 -6z m-1526 -27 c-72 -118 -139 -210 -142 -195 -7 34 21 89 75 147 50
54 86 80 67 48z m16 -113 c0 -7 -71 -105 -76 -105 -15 0 1 45 27 75 28 31 49
44 49 30z m2989 -106 c2 -75 -65 -235 -129 -310 l-29 -34 -1 34 0 35 -49 -70
c-82 -116 -170 -196 -286 -258 -50 -27 -49 -27 30 45 187 171 291 296 317 382
15 49 38 49 38 0 0 -35 1 -36 14 -18 18 27 54 140 62 195 9 67 14 79 24 55 5
-11 9 -36 9 -56z m-2979 6 c0 -12 -50 -104 -60 -110 -19 -12 -23 2 -11 37 16
46 39 78 56 78 8 0 15 -2 15 -5z m24 -97 c-3 -13 -14 -36 -23 -53 l-16 -30 -3
28 c-4 29 21 77 39 77 6 0 8 -9 3 -22z m2215 -185 c-24 -44 -146 -113 -200
-113 -32 0 -15 15 65 53 41 20 89 53 107 72 36 37 51 31 28 -12z m-1981 -24
c33 -14 49 -26 43 -32 -13 -13 -65 0 -96 24 -26 21 -35 45 -12 36 6 -3 36 -15
65 -28z m-465 -156 c-53 -76 -69 -93 -71 -76 -5 33 31 94 83 142 26 23 49 41
51 38 3 -3 -25 -49 -63 -104z m607 36 c93 -16 98 -18 80 -29 -36 -23 -141 -4
-182 31 l-23 20 30 -6 c17 -3 59 -10 95 -16z m160 -76 c2 -2 -2 -9 -10 -14
-22 -15 -109 -4 -128 15 -16 15 -12 16 58 10 41 -4 77 -9 80 -11z m-3080 -3
c0 -13 -70 -90 -81 -90 -19 0 -7 29 26 63 36 37 55 46 55 27z m2424 -2 c-26
-45 -106 -158 -115 -163 -42 -26 -1 80 52 134 36 38 80 58 63 29z m766 -38 c0
-24 -119 -41 -164 -24 -35 13 -12 23 62 27 42 1 83 4 90 5 6 1 12 -3 12 -8z
m-3121 -17 c-25 -33 -132 -148 -141 -151 -19 -8 -6 38 22 76 30 42 94 92 119
92 11 0 11 -3 0 -17z m3201 -43 c0 -12 -43 -20 -68 -13 -28 7 -28 21 1 25 29
4 67 -2 67 -12z m-834 -58 c-13 -26 -33 -58 -45 -72 l-20 -25 -1 23 c0 45 50
120 83 122 4 0 -4 -21 -17 -48z m-2346 -7 c0 -9 -62 -75 -71 -75 -17 0 -9 27
16 54 21 22 55 36 55 21z m1760 -33 c0 -11 -212 -104 -219 -96 -10 10 69 72
113 88 45 16 106 21 106 8z m3010 -7 c0 -22 -29 -75 -40 -75 -14 0 -13 12 5
54 16 37 35 48 35 21z m-2375 -76 c-10 -21 -22 -39 -27 -39 -16 0 -8 48 14 75
29 37 36 16 13 -36z m2286 40 c14 -27 6 -90 -15 -121 -15 -21 -16 -19 -16 60
0 83 9 101 31 61z m-131 -44 c28 -15 84 -84 75 -93 -2 -2 -21 9 -42 25 -21 16
-51 37 -66 46 -15 10 -25 22 -22 27 8 14 21 12 55 -5z m-240 -35 c42 -21 59
-40 37 -40 -20 0 -130 39 -141 50 -19 19 64 11 104 -10z m146 -4 c51 -24 77
-46 53 -46 -28 0 -89 24 -115 46 -26 21 -27 23 -9 24 11 0 43 -11 71 -24z
m774 -42 c0 -12 -3 -29 -6 -38 -11 -30 -24 -5 -24 47 1 48 2 50 15 33 8 -11
15 -30 15 -42z m-3495 16 c-9 -15 -175 -103 -182 -96 -10 10 47 64 91 86 42
21 102 28 91 10z m775 -44 c0 -14 -4 -27 -9 -31 -12 -7 -25 31 -16 45 11 18
25 10 25 -14z m-1510 -50 c-25 -23 -190 -108 -190 -97 0 5 20 27 45 49 44 39
89 59 135 61 21 1 22 -1 10 -13z m4100 -118 c-24 -65 -81 -149 -88 -130 -7 22
9 107 18 93 8 -14 44 54 71 134 l14 40 3 -41 c2 -24 -6 -64 -18 -96z m-1676
106 c3 -9 6 -23 6 -32 -1 -15 -3 -14 -15 2 -17 22 -20 46 -6 46 5 0 12 -7 15
-16z m-1694 -42 c0 -9 -102 -73 -108 -67 -10 10 10 36 40 55 33 20 68 26 68
12z m1810 -10 c0 -4 30 -43 66 -87 67 -81 71 -108 9 -61 -49 38 -114 156 -86
156 6 0 11 -4 11 -8z m-2570 -41 c0 -10 -173 -111 -190 -111 -5 0 -7 7 -3 15
8 22 80 70 133 88 54 19 60 20 60 8z m2891 -171 c81 -54 109 -68 109 -56 0 2
-14 34 -31 70 -17 37 -29 69 -27 71 2 3 26 -15 52 -39 48 -45 278 -208 284
-201 6 6 -25 60 -63 110 -20 26 -34 49 -32 52 7 7 85 -35 138 -73 53 -39 111
-118 134 -183 8 -24 14 -46 12 -48 -2 -2 -21 22 -42 54 -37 56 -133 159 -140
151 -2 -2 7 -32 21 -67 14 -34 24 -66 22 -71 -3 -7 -193 117 -287 188 -34 26
-39 17 -15 -29 8 -17 13 -33 11 -35 -6 -7 -93 29 -150 61 -83 47 -197 163
-197 201 0 3 25 -17 55 -45 31 -27 96 -77 146 -111z m1124 98 c-17 -123 -75
-231 -164 -303 l-23 -20 7 53 c4 28 4 52 1 52 -3 0 -22 -34 -42 -76 -35 -73
-126 -185 -140 -171 -4 4 23 55 59 115 68 111 108 193 121 246 12 48 26 11 26
-69 l1 -70 24 30 c33 40 91 158 107 218 16 63 32 60 23 -5z m-3245 5 c0 -10
-32 -43 -42 -43 -15 0 -8 29 10 39 20 12 32 14 32 4z m3626 -70 c15 -45 19
-87 19 -188 0 -144 -13 -205 -46 -205 -12 0 -21 -9 -25 -27 -29 -130 -70 -250
-81 -239 -2 2 4 44 13 92 12 58 18 139 18 232 1 111 4 139 13 126 6 -8 17 -39
23 -67 19 -81 27 -88 37 -32 10 60 10 309 -1 348 -12 51 10 20 30 -40z m-4416
18 c0 -12 -138 -106 -146 -99 -16 17 70 89 121 101 11 3 21 5 23 6 1 0 2 -3 2
-8z m-28 -141 c-32 -29 -62 -39 -62 -21 0 16 51 51 74 51 19 -1 18 -4 -12 -30z
m964 -29 c-20 -22 -74 -47 -82 -38 -11 11 8 29 49 47 47 21 58 18 33 -9z
m-906 -61 c0 -12 -40 -34 -47 -26 -9 8 17 36 33 36 8 0 14 -4 14 -10z m960
-10 c0 -12 -75 -60 -94 -60 -25 0 -8 25 32 48 40 23 62 28 62 12z m1249 -47
c19 -79 21 -93 12 -93 -12 0 -41 74 -41 105 0 38 18 30 29 -12z m101 -23 c0
-11 25 -68 55 -126 31 -59 53 -109 50 -112 -10 -11 -66 53 -90 103 -28 59 -44
155 -26 155 6 0 11 -9 11 -20z m-1290 -5 c0 -14 -48 -45 -70 -45 -21 0 -9 21
23 40 38 24 47 25 47 5z m60 -69 c0 -12 -34 -36 -51 -36 -26 0 -24 14 4 28 23
11 47 15 47 8z m-2744 -118 c-3 -50 -8 -94 -11 -96 -13 -13 -20 16 -20 81 0
77 7 107 26 107 9 0 10 -24 5 -92z m4127 20 c20 -29 63 -80 97 -113 33 -33 60
-63 60 -67 0 -11 -56 18 -98 50 -18 14 -46 44 -62 66 -28 42 -55 116 -41 116
4 0 24 -24 44 -52z m-3113 29 c0 -10 -171 -120 -176 -114 -12 12 45 74 88 96
37 18 88 28 88 18z m-940 -53 c0 -32 -4 -44 -12 -42 -18 6 -21 29 -9 61 15 39
21 33 21 -19z m2695 36 c-3 -5 -13 -10 -21 -10 -8 0 -12 5 -9 10 3 6 13 10 21
10 8 0 12 -4 9 -10z m-2851 -62 c9 -36 7 -138 -3 -138 -18 0 -35 89 -26 130 8
36 20 39 29 8z m5941 -159 c-24 -94 -71 -176 -141 -246 -98 -100 -102 -89 -35
101 40 113 60 127 42 29 -6 -31 -9 -58 -7 -60 7 -7 92 158 122 237 28 71 29
73 32 38 2 -20 -4 -65 -13 -99z m-5244 43 c-63 -100 -109 -194 -155 -309 -43
-112 -46 -137 -10 -94 40 48 45 37 14 -32 -32 -72 -50 -136 -85 -306 -13 -65
-31 -134 -39 -152 -16 -33 -16 -31 -12 61 2 52 12 126 21 164 15 56 16 69 5
76 -11 7 -12 20 -2 72 33 178 147 419 266 560 50 59 49 44 -3 -40z m364 70
c-58 -52 -147 -122 -155 -122 -14 0 13 50 42 77 12 12 37 29 53 37 32 17 76
22 60 8z m3430 -73 c48 -65 56 -86 28 -70 -37 20 -93 92 -93 120 0 25 23 7 65
-50z m-3518 -97 c-26 -25 -50 -43 -54 -38 -12 12 20 59 57 84 52 35 50 8 -3
-46z m1338 -21 c40 -15 104 -49 141 -74 71 -47 142 -113 132 -122 -3 -3 -29
11 -59 32 -150 103 -234 151 -246 139 -3 -3 6 -15 20 -27 15 -11 27 -24 27
-28 0 -5 -44 7 -99 25 -54 18 -128 38 -165 45 -36 7 -66 16 -66 21 0 15 77 8
169 -16 50 -13 91 -20 91 -15 0 5 -22 20 -50 34 -27 14 -50 27 -50 29 0 8 86
-16 155 -43z m2425 -27 c36 -41 56 -81 47 -90 -9 -9 -35 14 -69 60 -49 68 -32
91 22 30z m-3709 -12 c-29 -40 -80 -86 -87 -79 -10 10 15 62 39 85 45 40 78
36 48 -6z m4678 -70 c-31 -97 -107 -209 -185 -274 -26 -21 -49 -36 -52 -34 -2
3 3 26 12 52 9 26 14 49 13 51 -2 2 -31 -30 -65 -71 -57 -70 -167 -165 -177
-154 -3 3 22 36 56 74 74 83 165 201 207 269 l32 50 0 -41 c0 -22 -6 -62 -14
-87 -8 -26 -11 -47 -6 -47 18 0 140 179 173 252 17 40 22 9 6 -40z m-832 23
c27 -19 63 -77 63 -101 0 -14 -7 -11 -36 17 -31 30 -64 78 -64 94 0 9 15 5 37
-10z m-1377 -18 c0 -3 -66 -142 -79 -166 -12 -22 -31 -25 -31 -4 1 34 27 91
59 132 27 34 51 52 51 38z m-958 -112 c114 -46 221 -135 256 -214 10 -20 27
-50 40 -68 26 -36 72 -132 72 -150 0 -26 -16 -11 -49 45 -46 76 -134 161 -199
191 -29 14 -52 28 -52 33 0 13 33 9 78 -12 23 -10 42 -15 42 -10 0 17 -97 93
-185 146 -122 72 -127 76 -90 68 17 -4 56 -17 87 -29z m2502 9 c3 -9 6 -27 6
-42 0 -34 -17 -17 -26 26 -7 33 9 46 20 16z m-1562 -111 c-30 -82 -52 -105
-52 -54 0 39 16 80 42 109 36 38 39 25 10 -55z m2312 -129 c-75 -179 -109
-251 -132 -276 -19 -22 -30 -23 -34 -1 -2 11 -16 -4 -42 -43 -139 -211 -303
-373 -584 -578 -29 -21 -55 -36 -57 -34 -3 2 41 54 97 114 95 103 170 202 183
245 4 10 10 19 15 19 9 0 -1 -48 -19 -94 -17 -42 -9 -41 30 7 56 67 98 132
132 205 34 73 46 66 23 -13 -9 -27 -14 -50 -12 -52 6 -6 181 230 223 300 l42
71 3 -45 3 -44 34 95 c19 52 41 109 49 125 25 52 103 168 108 162 3 -2 -25
-76 -62 -163z m-2628 132 c8 -33 2 -69 -13 -74 -9 -2 -13 11 -13 47 0 53 15
69 26 27z m379 -28 c-4 -13 -9 -32 -11 -43 -10 -39 -27 -75 -35 -75 -16 0 -9
60 11 100 22 43 46 55 35 18z m-319 -247 c3 -11 11 -5 25 18 11 18 22 31 25
29 8 -8 -31 -163 -41 -163 -14 0 -34 46 -45 106 -11 56 -6 127 13 194 11 37
12 33 15 -65 1 -58 5 -111 8 -119z m379 112 c-3 -13 -10 -21 -15 -18 -14 9
-12 69 3 84 10 10 13 7 15 -15 2 -14 1 -37 -3 -51z m1199 -75 c3 -29 8 -123
11 -208 4 -85 11 -202 16 -260 13 -134 60 -437 85 -545 10 -42 -26 34 -51 108
-34 103 -53 195 -76 376 -26 212 -26 581 1 581 4 0 10 -24 14 -52z m-2969 -35
c-12 -32 -25 -66 -28 -75 -9 -26 -27 -22 -27 6 0 34 18 77 42 104 34 35 37 26
13 -35z m941 -8 c99 -82 193 -244 219 -379 28 -143 14 -141 -40 6 -49 136 -97
225 -172 326 -34 45 -59 82 -56 82 3 0 25 -16 49 -35z m-872 -36 c-4 -7 -17
-50 -28 -97 -27 -106 -52 -125 -43 -33 5 62 43 141 68 141 5 0 7 -5 3 -11z
m-1374 -83 c-37 -107 -51 -213 -48 -351 2 -114 0 -130 -14 -133 -22 -4 -33 62
-32 198 0 84 6 120 26 182 25 74 75 174 84 165 2 -2 -5 -30 -16 -61z m2802
-48 c21 -111 46 -198 57 -198 5 0 6 11 3 25 -7 41 4 29 47 -50 22 -42 83 -142
134 -223 52 -81 154 -248 227 -372 193 -327 247 -404 374 -539 l51 -54 -50 34
c-115 77 -192 165 -325 374 -107 169 -407 677 -433 734 -14 32 -21 40 -28 30
-13 -21 -32 4 -59 76 -24 63 -41 255 -24 255 5 0 17 -42 26 -92z m-1367 -55
c-4 -43 -11 -85 -15 -93 -14 -25 -32 38 -25 85 7 38 29 85 41 85 3 0 3 -35 -1
-77z m-966 -20 c-6 -16 -27 -71 -46 -123 -40 -109 -49 -124 -59 -86 -12 49 21
145 72 205 32 38 47 40 33 4z m1058 -89 c-7 -93 -25 -104 -34 -21 -5 45 9 87
29 87 7 0 9 -21 5 -66z m1782 -101 c1 -59 -12 -69 -28 -22 -14 41 -14 100 1
136 l11 28 8 -45 c4 -25 8 -69 8 -97z m-1669 34 c0 -19 -4 -27 -12 -25 -15 5
-22 42 -13 66 5 14 7 14 15 2 6 -8 10 -28 10 -43z m-1164 -112 c-14 -65 -28
-120 -31 -123 -22 -22 -30 75 -11 139 17 59 57 130 63 113 2 -6 -8 -64 -21
-129z m2909 53 c3 -35 9 -76 12 -91 4 -24 2 -28 -13 -25 -21 4 -32 35 -33 100
-2 95 24 107 34 16z m-958 -7 c38 -56 63 -148 63 -231 0 -73 -23 -170 -40
-170 -4 0 -11 17 -14 38 -14 77 -18 92 -27 92 -5 0 -9 -33 -9 -73 0 -39 -4
-87 -10 -106 -10 -37 -59 -116 -66 -108 -3 2 9 71 26 153 16 82 30 166 30 187
0 20 4 37 8 37 4 0 19 -21 32 -47 16 -34 25 -43 28 -30 6 29 -17 157 -43 230
-25 72 -16 84 22 28z m-1854 -118 c-2 -60 -6 -118 -9 -130 -13 -67 -49 31 -41
112 5 49 34 125 47 125 4 0 5 -48 3 -107z m4367 83 c0 -33 -17 -76 -30 -76
-13 0 -13 56 0 81 15 26 30 24 30 -5z m-4920 -176 c13 -116 42 -255 69 -334
12 -33 19 -61 17 -64 -8 -7 -72 128 -94 198 -45 141 -54 284 -21 355 l13 30 3
-45 c2 -25 8 -88 13 -140z m3455 113 c3 -27 9 -58 12 -70 7 -32 -21 -30 -35 2
-13 28 -16 107 -6 118 13 13 22 -3 29 -50z m-356 -22 c24 -56 25 -65 11 -56
-22 13 -58 105 -42 105 5 0 19 -22 31 -49z m1739 -18 c-3 -55 -21 -65 -26 -15
-4 39 3 62 18 62 7 0 10 -18 8 -47z m-1279 -10 c11 -39 1 -63 -16 -41 -14 18
-24 63 -16 72 13 13 22 5 32 -31z m-2905 -44 c3 -34 6 -76 6 -93 0 -28 -1 -29
-16 -14 -28 27 -32 168 -5 168 4 0 11 -28 15 -61z m4114 -13 c2 -28 0 -37 -10
-34 -7 3 -14 22 -16 42 -2 28 0 37 10 34 7 -3 14 -22 16 -42z m-3918 -108 c0
-17 -2 -18 -16 -8 -22 19 -36 49 -28 62 10 15 44 -27 44 -54z m3835 -103 c9
-30 15 -69 13 -87 l-3 -33 -19 29 c-23 32 -36 146 -17 146 6 0 18 -25 26 -55z
m-2408 -94 c-8 -69 -40 -126 -87 -157 -22 -15 -43 -24 -46 -21 -3 3 12 30 35
59 22 30 52 79 66 111 15 31 29 57 32 57 3 0 3 -22 0 -49z m3166 14 c59 -25
50 -32 -36 -27 -63 3 -95 0 -139 -15 -88 -30 -72 2 19 37 59 23 109 25 156 5z
m-675 -22 c26 -68 34 -105 25 -114 -16 -16 -46 40 -51 93 -5 53 9 64 26 21z
m102 -80 c0 -20 -18 -16 -30 7 -15 28 -1 49 17 25 7 -11 13 -25 13 -32z
m-1422 -55 c5 -18 7 -37 4 -41 -7 -14 -21 6 -28 41 -9 43 13 43 24 0z m-3095
-119 c56 -76 115 -135 124 -125 3 3 0 19 -6 37 -23 66 -11 64 68 -13 102 -98
208 -152 420 -213 85 -25 159 -49 163 -53 12 -12 -170 14 -265 38 -111 28
-198 74 -277 147 -37 34 -73 63 -79 63 -22 0 -10 -23 35 -67 25 -24 44 -47 41
-50 -13 -12 -103 43 -163 100 -46 43 -74 79 -98 131 -38 77 -57 137 -34 102 7
-11 39 -54 71 -97z m4100 75 c43 -21 49 -39 10 -29 -108 27 -156 29 -263 10
-30 -6 -32 -5 -15 6 65 41 196 48 268 13z m1115 -6 c43 -47 57 -143 26 -186
-25 -36 -32 -26 -26 46 3 55 0 78 -16 115 -23 51 -17 60 16 25z m-3362 -13
c55 -23 54 -39 -2 -29 -78 14 -242 9 -314 -10 -87 -24 -186 -66 -255 -111 -74
-47 -67 -28 10 30 95 71 209 119 330 138 49 8 197 -3 231 -18z m1344 -75 c13
-40 10 -57 -9 -46 -13 8 -32 76 -25 88 9 14 20 1 34 -42z m1785 9 c43 -38 61
-95 45 -144 -6 -19 -20 -37 -31 -40 -27 -9 -33 -1 -20 23 14 27 14 97 0 125
-6 12 -21 32 -32 45 -30 33 -3 27 38 -9z m-2903 -49 c52 -45 89 -115 90 -169
0 -47 -10 -70 -23 -50 -5 8 -9 25 -9 39 0 46 -46 124 -104 178 -31 29 -56 55
-56 57 0 13 66 -22 102 -55z m1194 -5 c17 -41 18 -55 3 -55 -13 0 -42 68 -34
80 10 16 15 12 31 -25z m84 -31 c0 -8 -4 -14 -10 -14 -12 0 -31 35 -23 44 9 8
33 -14 33 -30z m-659 -23 c-6 -11 -32 -35 -57 -53 -27 -19 -40 -34 -32 -36 11
-2 112 29 308 94 8 3 4 -5 -10 -17 -67 -59 -276 -124 -432 -134 -81 -6 -91 -5
-75 8 9 8 17 19 17 24 0 6 17 13 38 17 44 7 139 51 202 94 49 34 57 34 41 3z
m1544 -79 c8 -25 15 -58 15 -74 0 -31 -25 -88 -39 -88 -4 0 -8 33 -7 73 0 58
-5 83 -27 131 -15 32 -27 61 -27 64 0 3 16 -9 35 -28 19 -18 41 -53 50 -78z
m-1769 29 c-45 -46 -134 -89 -209 -101 -87 -13 -91 5 -6 30 75 22 215 85 225
101 3 5 10 9 17 9 6 0 -6 -18 -27 -39z m-481 7 c51 -34 78 -83 83 -147 3 -46
0 -61 -17 -81 l-20 -25 -1 65 c-1 74 -21 128 -68 178 -34 37 -23 42 23 10z
m1840 -70 c52 -40 81 -140 55 -189 -6 -10 -17 -19 -24 -19 -10 0 -15 20 -18
73 -3 60 -8 82 -31 115 -30 46 -24 53 18 20z m-2150 -53 c59 -34 104 -111 88
-151 -9 -25 -31 -15 -38 19 -11 48 -43 95 -88 128 -50 37 -22 40 38 4z"
        />
        <path
          d="M6484 7735 c-4 -15 -4 -55 0 -89 5 -54 4 -65 -13 -80 -21 -19 -71
-25 -113 -13 -25 6 -28 5 -28 -15 0 -98 80 -188 205 -233 122 -42 187 -73 217
-102 l27 -26 11 27 c5 15 10 31 10 36 0 5 21 39 46 77 58 83 74 121 74 170 0
46 -29 110 -62 141 l-25 23 -17 -26 c-13 -20 -24 -25 -59 -25 -38 0 -48 6 -87
46 -47 47 -119 97 -157 108 -18 6 -24 2 -29 -19z m198 -174 c134 -85 143 -297
11 -262 -73 20 -133 107 -133 195 0 99 39 120 122 67z m190 -36 c8 -19 8 -28
-2 -40 -25 -31 -70 -11 -70 31 0 40 55 46 72 9z m-373 -54 c23 -23 18 -58 -11
-66 -24 -8 -68 20 -68 43 0 42 47 55 79 23z"
        />
        <path
          d="M6609 7523 c-23 -62 49 -189 103 -181 20 3 23 10 26 48 3 52 -32 116
-78 144 -37 21 -39 21 -51 -11z"
        />
        <path
          d="M6816 7004 c-8 -32 18 -77 42 -72 23 4 27 44 8 74 -21 31 -42 31 -50
-2z"
        />
        <path
          d="M7604 6893 c-3 -10 -16 -42 -30 -70 l-24 -53 23 0 c56 0 88 60 61
112 -17 33 -23 35 -30 11z"
        />
        <path
          d="M5590 6255 l-35 -13 30 -3 c18 -3 30 -10 30 -19 0 -22 -97 -26 -119
-5 -13 14 -21 14 -56 4 -22 -7 -40 -15 -40 -19 0 -14 96 -51 150 -57 45 -4 59
-10 63 -24 5 -18 10 -17 74 13 37 17 72 35 77 39 12 11 -18 44 -66 75 -42 27
-58 28 -108 9z"
        />
        <path
          d="M5800 6528 c0 -24 7 -54 16 -66 31 -45 109 -66 155 -42 30 16 23 27
-35 53 -29 14 -72 41 -95 62 l-41 37 0 -44z"
        />
        <path
          d="M7759 6583 c-24 -6 -44 -54 -27 -64 16 -11 45 -11 51 -1 3 4 8 22 12
40 7 33 3 36 -36 25z"
        />
      </g>
    </svg>
  )
}
